const getFields = document.querySelectorAll('.no-js');

getFields.forEach(getField => {
  getField.classList.remove('no-js');
});
